/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetYoutubeCapabilitiesQueryResponse, SocialExportGetYoutubeCapabilitiesPathParams, SocialExportGetYoutubeCapabilities400, SocialExportGetYoutubeCapabilities401, SocialExportGetYoutubeCapabilities403, SocialExportGetYoutubeCapabilities404 } from "../models/SocialExportGetYoutubeCapabilities";

export function getSocialExportGetYoutubeCapabilitiesUrl(connectionId: SocialExportGetYoutubeCapabilitiesPathParams["connectionId"]) {
  const res = { method: 'GET', url: `/social-export/v1/platforms/youtube/${connectionId}/capabilities` as const }
  return res
}

/**
 * @description Returns which actions the stored OAuth credentials can perform (upload, delete, add to playlists).
 * @summary Get YouTube connection capabilities
 * {@link /social-export/v1/platforms/youtube/:connectionId/capabilities}
 */
export async function socialExportGetYoutubeCapabilities(connectionId: SocialExportGetYoutubeCapabilitiesPathParams["connectionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportGetYoutubeCapabilitiesQueryResponse, ResponseErrorConfig<SocialExportGetYoutubeCapabilities400 | SocialExportGetYoutubeCapabilities401 | SocialExportGetYoutubeCapabilities403 | SocialExportGetYoutubeCapabilities404>, unknown>({ method : "GET", url : getSocialExportGetYoutubeCapabilitiesUrl(connectionId).url.toString(), ... requestConfig })
  return res.data
}